import React from 'react';
import { Star } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

/** Trois avis clients : avis = [{ text, name, ville }]. */
const AvisSection = ({ titre = 'Avis de nos clients', sousTitre, avis }) => (
  <section className="py-16 px-4 bg-white" data-testid="avis-section">
    <div className="max-w-7xl mx-auto">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">{titre}</h2>
        {sousTitre && <p className="text-lg text-gray-600">{sousTitre}</p>}
      </div>

      <div className="grid md:grid-cols-3 gap-8">
        {avis.map((a) => (
          <Card key={a.name} className="bg-gray-50">
            <CardContent className="p-6">
              <div className="flex items-center gap-1 mb-4">
                {[0, 1, 2, 3, 4].map((i) => <Star key={`${a.name}-${i}`} className="w-5 h-5 fill-yellow-400 text-yellow-400" />)}
              </div>
              <p className="text-gray-700 mb-4">"{a.text}"</p>
              <div className="font-semibold text-gray-900">{a.name}</div>
              <div className="text-sm text-gray-600">{a.ville}</div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  </section>
);

export default AvisSection;
